import { FormattedMessage } from 'react-intl';

interface PinCodeSubmitHintProps {
    show: boolean;
}

export const PinCodeSubmitHint = ({ show }: PinCodeSubmitHintProps) => {
    if (!show) {
        return null;
    }

    return (
        <div className='text-brand-muted mt-2 self-stretch text-center text-base font-medium'>
            <FormattedMessage
                id='kiosk.wizard.pin-code.submit-hint'
                defaultMessage='Press the button below to verify your PIN-code.'
                description='Hint shown on kiosk wizard PIN-code screens when the full PIN has been entered, prompting the user to use the footer submit button'
            />
        </div>
    );
};
